'use client';

import Script from 'next/script';
import { initializeBingUET } from '~/services/analytics/providers/bing';

export default function BingScript() {
  return (
    <Script
      src="https://bat.bing.com/bat.js"
      strategy="afterInteractive"
      id="bing-uet"
      onLoad={initializeBingUET}
    />
  );
}
